import assest from "../../../Assets/Img/assest.webp"
import barcode from "../../../Assets/Img/assest.webp"
import tracking from "../../../Assets/Img/tracking.webp"
import realtime from "../../../Assets/Img/realtime.webp"
import batch from "../../../Assets/Img/batch.webp"
import inventorymobile from "../../../Assets/Img/inventorymobile.webp"
import salecrm from "../../../Assets/Img/salecrm.webp"
import ecomerce from "../../../Assets/Img/ecomerce.webp"
import purchases from "../../../Assets/Img/purchases.webp"

const Data=[
    {
        Img:assest,
        heading:"Asset Tracking",
        text:"Track your assets and equipment anywhere and everywhere."
    },
    {
        Img:barcode,
        heading:"Barcode Scanning",
        text:"Scan 1D, 2D and QR Barcodes to help you track many types of goods.."
    },
    {
        Img:tracking,
        heading:"Pallet Tracking",
        text:"We help track pallets, containers, bundles and group of items in a single scan."
    },
    {
        Img:realtime,
        heading:"Real Time Tracking",
        text:"As long as you’re connected, you can track everything in real time."
    },
    {
        Img:batch,    
        heading:"Batch Tracking",
        text:"Track your goods by batches, including expiry, manufacturing dates and etc."
    },
    {
        Img:inventorymobile,
        heading:"Mobile Inventory",
        text:"Track Your Inventory Just with your Mobile.."
    },
    {
        Img:salecrm,
        heading:"Sales & CRM",
        text:"Follow your sales process from sales lead to confirmed order"
    },
    {
        Img:ecomerce,
        heading:"Ecommerce",
        text:"Shopee, Lazada and more. We are integrated with some E-Commerce platforms already."
    },
    {
        Img:purchases,
        heading:"Purchases",
        text:"Re-stock and replenish goods made easy."
    },
]
export default Data;